import React, { useState } from 'react';
import ContactForm from '../components/ContactForm';
import QuoteForm from '../components/QuoteForm';
import './Contact.css';

const Contact = () => {
  const [activeForm, setActiveForm] = useState('contact');

  return (
    <div className="contact-page">
      <div className="container">
        <h1 className="contact-title">Get In Touch</h1>
        <p className="contact-subtitle">
          Your trusted authorized distributor for Masai Cables, Versil Pumps, and Masai Rolling Mills.
          We're here to help with all your industrial supply needs.
        </p>

        <div className="form-tabs">
          <button 
            className={`tab-btn ${activeForm === 'contact' ? 'active' : ''}`}
            onClick={() => setActiveForm('contact')}
          >
            <span className="tab-icon">📧</span>
            Contact MasaiLink
          </button>
          <button 
            className={`tab-btn ${activeForm === 'quote' ? 'active' : ''}`}
            onClick={() => setActiveForm('quote')}
          >
            <span className="tab-icon">📋</span>
            Request Quote
          </button>
        </div>

        <div className="contact-grid">
          {/* Left Column - Contact Info */}
          <div className="contact-info-section">
            <div className="brand-badge">
              <h2>MasaiLink</h2>
              <p className="authorized-tag">✓ Authorized Distributor</p>
            </div>
            
            <div className="info-card">
              <div className="info-icon">📍</div>
              <h3>Kitengela Office</h3>
              <p>P.O. Box 344 - 00242<br />Kitengela, Kenya<br />Off Mombasa Road</p>
              <a 
                href="https://maps.google.com/?q=Kitengela+Kenya" 
                target="_blank" 
                rel="noopener noreferrer"
                className="map-link"
              >
                View on Map →
              </a>
            </div>

            <div className="info-card">
              <div className="info-icon">🏢</div>
              <h3>Nairobi Office</h3>
              <p>Industrial Area<br />Nairobi, Kenya<br />By appointment only</p>
              <a 
                href="https://maps.google.com/?q=Industrial+Area+Nairobi" 
                target="_blank" 
                rel="noopener noreferrer"
                className="map-link"
              >
                View on Map →
              </a>
            </div>

            <div className="info-card highlight">
              <div className="info-icon">📞</div>
              <h3>Call Us Directly</h3>
              <p className="phone-number">📱 <strong>0115 016 167</strong></p>
              <p className="email">✉️ <strong>masailink@masaigroup.co.ke</strong></p>
              <div className="quick-actions">
                <a href="tel:0115016167" className="quick-action-btn">Call Now</a>
                <a href="https://wa.me/254115016167" className="quick-action-btn whatsapp">WhatsApp</a>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">⏰</div>
              <h3>Business Hours</h3>
              <p>Monday - Friday: 8:00 AM - 5:00 PM<br />Saturday: 9:00 AM - 1:00 PM<br />Sunday: Closed</p>
            </div>

            <div className="products-badge">
              <p>We supply:</p>
              <div className="badge-items">
                <span className="badge-item">⚡ Masai Cables</span>
                <span className="badge-item">💧 Versil Pumps</span>
                <span className="badge-item">🔩 Masai Steel</span>
              </div>
            </div>

            <div className="social-section">
              <h3>Follow MasaiLink</h3>
              <div className="social-links">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <span className="social-icon-emoji">📘</span> Facebook
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <span className="social-icon-emoji">🐦</span> Twitter
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <span className="social-icon-emoji">📷</span> Instagram
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <span className="social-icon-emoji">🔗</span> LinkedIn
                </a>
              </div>
            </div>
          </div>

          {/* Right Column - Forms */}
          <div className="contact-form-wrapper">
            {activeForm === 'contact' ? <ContactForm /> : <QuoteForm />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;